import { MFA_WEB_AUTHN_NAME } from '../../constants/ui.labels'
import styles from './SetupMFAWebAuthnRegisterAnimation.module.css'
import IconWithProvider from '@talkdesk/cobalt-react-icon'
import { useTheme } from '@talkdesk/cobalt-react-theme-provider'

const SetupMFAWebAuthnRegisterAnimation = ({
  isValid = false,
  securityKeyAnimationUrl,
}) => {
  const theme = useTheme()
  return (
    <div
      className={`${styles['svg-animation']}${isValid ? ` ${styles.ok}` : ''}`}
    >
      <div className='co--push-right'>
        {/* using an object to force rendering the svg animation, which doesn't reset when re-rendered */}
        <object
          type='image/svg+xml'
          data={securityKeyAnimationUrl}
          aria-label=''
        >
          {MFA_WEB_AUTHN_NAME}
        </object>
      </div>
      <div className={`${styles['svg-success']} co--push-center`}>
        <IconWithProvider name='check' size='xlarge' color={theme.green600} />
      </div>
    </div>
  )
}

export default SetupMFAWebAuthnRegisterAnimation
